<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="New Customer" scrollable hide-footer size="lg" @hidden="resetForm">
            <template v-slot:modal-title>
                <span>New Customer:</span>
            </template>

            <b-form @submit.stop.prevent="createCustomer">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="create.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-company"
                            label="Company:"
                            label-for="input-company"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-company"
                                v-model="create.company"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-buyer-name"
                            label="Buyer Name:"
                            label-for="input-buyer-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-buyer-name"
                                v-model="create.buyerName"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-email"
                            label="Email:"
                            label-for="input-email"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-email"
                                v-model="create.email"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-phone"
                                    label="Phone:"
                                    label-for="input-phone"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-phone"
                                        v-model="create.phone"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-mobile"
                                    label="Mobile:"
                                    label-for="input-mobile"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-mobile"
                                        v-model="create.mobile"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-fax"
                                    label="Fax:"
                                    label-for="input-fax"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-fax"
                                        v-model="create.fax"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="4">
                                <b-form-group
                                    id="input-group-other"
                                    label="Other:"
                                    label-for="input-other"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-other"
                                        v-model="create.other"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="8">
                                <b-form-group
                                    id="input-group-website"
                                    label="Website:"
                                    label-for="input-website"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-website"
                                        v-model="create.website"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-row>

                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Address" active>
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <p>Billing Address:</p>
                                            <b-form-group
                                                id="textarea-group-billing-address-1"
                                            >
                                                <b-form-input
                                                    id="input-billing-address-1"
                                                    v-model="create.billingAddress1"
                                                    type="text"
                                                    placeholder="Address 1"
                                                    size="sm"
                                                    autocomplete="off"
                                                >
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group
                                                id="textarea-group-billing-address-2"
                                            >
                                                <b-form-input
                                                    id="input-billing-address-2"
                                                    v-model="create.billingAddress2"
                                                    type="text"
                                                    placeholder="Address 2"
                                                    size="sm"
                                                    autocomplete="off"
                                                >
                                                </b-form-input>
                                            </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-city"
                                                >
                                                    <b-form-input
                                                        id="input-billing-city"
                                                        v-model="create.billingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-state"
                                                >
                                                    <b-form-input
                                                        id="input-billing-state"
                                                        v-model="create.billingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-zip"
                                                >
                                                    <b-form-input
                                                        id="input-billing-zip"
                                                        v-model="create.billingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-country"
                                                >
                                                    <b-form-input
                                                        id="input-billing-country"
                                                        v-model="create.billingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                    <b-col>
                                        <p>Shipping Address:</p>
                                            <b-form-group
                                                id="textarea-group-shipping-address-1"
                                            >
                                                <b-form-input
                                                    id="input-shipping-address-1"
                                                    v-model="create.shippingAddress1"
                                                    type="text"
                                                    placeholder="Address 1"
                                                    size="sm"
                                                    autocomplete="off"
                                                >
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group
                                                id="textarea-group-shipping-address-2"
                                            >
                                                <b-form-input
                                                    id="input-shipping-address-2"
                                                    v-model="create.shippingAddress2"
                                                    type="text"
                                                    placeholder="Address 2"
                                                    size="sm"
                                                    autocomplete="off"
                                                >
                                                </b-form-input>
                                            </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-city"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-city"
                                                        v-model="create.shippingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-state"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-state"
                                                        v-model="create.shippingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-zip"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-zip"
                                                        v-model="create.shippingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-country"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-country"
                                                        v-model="create.shippingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Notes">
                            <b-card-text>
                                <b-form-group
                                    id="textarea-group-notes"
                                    label="Notes:"
                                    label-for="textarea-notes"
                                    label-size="sm"
                                >
                                    <b-form-textarea
                                        id="textarea-notes"
                                        v-model="create.notes"
                                        placeholder=""
                                        rows="7"
                                        size="sm"
                                        no-resize
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Tax Info">
                            <b-card-text>
                                <b-form-group
                                    id="input-group-reseller-permit"
                                    label="Reseller Permit #:"
                                    label-for="input-reseller-permit"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-reseller-permit"
                                        v-model="create.resellerPermit"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Payment and Billing">
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <b-form-group
                                            id="select-group-payment-method"
                                            label="Preferred Payment Terms:"
                                            label-for="select-payment-method"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="create.paymentMethod"
                                                id="select-payment-method"
                                                size="sm"
                                                :options="lists.paymentMethods"
                                            ></b-form-select>
                                        </b-form-group>
                                        <b-form-group
                                            id="select-group-delivery-method"
                                            label="Preferred Delivery Method:"
                                            label-for="select-delivery-method"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="create.deliveryMethod"
                                                id="select-delivery-method"
                                                size="sm"
                                                :options="lists.deliveryMethods"
                                            ></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group
                                            id="input-group-opening-balance"
                                            label="Opening Balance:"
                                            label-for="input-opening-balance"
                                            label-size="sm"
                                        >
                                            <b-form-input
                                                id="input-opening-balance"
                                                v-model="create.openingBalance"
                                                type="text"
                                                placeholder=""
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Cards On File" v-if="$can('edit-customer-detail-payment-method') || $can('view-all')">
                            <b-card-text>
                                <b-table-simple hover small bordered>
                                    <b-thead>
                                        <b-th class="default-card"></b-th>
                                        <b-th style="min-width: 220px; width: 220px;">Number</b-th>
                                        <b-th>Exp</b-th>
                                        <b-th>CVC {{ paymentConfig.cvc_required ? '(Required)' : '(Optional)' }}</b-th>
                                        <b-th>Kaja</b-th>
                                        <b-th></b-th>
                                    </b-thead>
                                    <b-tbody>
                                        <!-- Pending cards (not yet saved) -->
                                        <b-tr v-for="(card, index) in pendingCards" :key="'pending-' + index" class="pending-card-row">
                                            <b-td></b-td>
                                            <b-td>
                                                <b-form-input :id="'input-pending-cards-number' + index" :value="formatCardDisplay(card.number, 'number')" type="text" placeholder="" size="sm" autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-pending-cards-exp' + index" :value="formatCardDisplay(card.exp, 'exp')" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-pending-cards-cvc' + index" :value="formatCardDisplay(card.cvc, 'cvc')" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td class="text-center">
                                                <span class="text-muted"><small>Pending</small></span>
                                            </b-td>
                                            <b-td>
                                                <b-button variant="danger" class="btn-sm" @click="removePendingCard(index)">Remove</b-button>
                                            </b-td>
                                        </b-tr>
                                        <!-- Saved cards (from API) -->
                                        <b-tr v-for="(card, index) in lists.cards" :key="'saved-' + index">
                                            <b-td :class="{ 'highlight-green': card.default }" />
                                            <b-td>
                                                <b-form-input :id="'input-cards-number' + index" :value="formatCardDisplay(card.number, 'number')" type="text" placeholder="" size="sm" autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-cards-exp' + index" :value="formatCardDisplay(card.exp, 'exp')" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-cards-cvc' + index" :value="formatCardDisplay(card.cvc, 'cvc')" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td class="text-center">
                                                <span v-if="card.kaja_payment_method_id">
                                                    <i class="fa fa-check text-success"></i>
                                                </span>
                                                <span v-else>
                                                    <i class="fa fa-times text-danger"></i>
                                                </span>
                                            </b-td>
                                            <b-td>
                                                <b-button class="btn-sm" v-if="!card.default" @click="makeDefault(card.id)">Make Default</b-button>
                                                <b-button variant="danger" class="btn-sm" v-if="!card.default" @click="deleteCard(card.id)">X</b-button>
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                    <b-tfoot>
                                        <b-tr>
                                            <b-td></b-td>
                                            <b-td>
                                                <b-form-input 
                                                    id="input-new-number" 
                                                    v-model="create.newCard.number" 
                                                    type="text" 
                                                    size="sm" 
                                                    autocomplete="off"
                                                    @input="formatCardNumber"
                                                    placeholder="Card number (no spaces)"
                                                />
                                            </b-td>
                                            <b-td>
                                                <b-form-input 
                                                    id="input-new-exp" 
                                                    v-model="create.newCard.exp" 
                                                    type="text" 
                                                    size="sm" 
                                                    autocomplete="off"
                                                    @input="formatExpiry"
                                                    placeholder="MM/YY"
                                                />
                                            </b-td>
                                            <b-td>
                                                <b-form-input 
                                                    id="input-new-cvc" 
                                                    v-model="create.newCard.cvc" 
                                                    type="text" 
                                                    size="sm" 
                                                    autocomplete="off"
                                                    @input="formatCVC"
                                                    :placeholder="paymentConfig.cvc_required ? 'CVC' : 'CVC (Optional)'"
                                                />
                                            </b-td>
                                            <b-td>
                                                <b-button v-if="create.newCard.number && create.newCard.exp" variant="success" class="btn-sm" @click="createCard">ADD CARD</b-button>
                                            </b-td>
                                        </b-tr>
                                    </b-tfoot>
                                </b-table-simple>
                                
                                <!-- Permission notice -->
                                <div v-if="!($can('view-customer-detail-payment-method-full-card') || $can('view-all'))" class="mt-2">
                                    <small class="text-muted">
                                        <i class="fas fa-info-circle"></i> 
                                        Card details are masked. Contact your administrator for full access to view complete card information.
                                    </small>
                                </div>
                                
                                <!-- CVC requirement notice -->
                                <div class="mt-2">
                                    <small class="text-muted">
                                        <i class="fas fa-info-circle"></i> 
                                        CVC is currently {{ paymentConfig.cvc_required ? 'required' : 'optional' }} for card creation.
                                    </small>
                                </div>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Additional Info">
                            <b-card-text></b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Creating...
                            </span>
                            <span v-else>Create</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
    import { fetchActivePaymentTerms } from '../../../../../utils/paymentTerms'
    import { fetchActiveShippingMethods } from '../../../../../utils/shippingMethods'

	export default {
		props: [

		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-lists-customers-create-customer',
                paymentConfig: {
                    cvc_required: false
                },
                create: {
                    newCard: {
                        number: '',
                        exp: '',
                        cvc: ''
                    }
                },
                lists: {
                    cards: [],
                    paymentMethods: [],
                    deliveryMethods: [],
                },
                pendingCards: [], // Cards added but not yet saved via API
                submitting: 0,
                createdCustomerId: null,
			}
		},

		methods: {
            async createCustomer(forceCreate = false) {
                this.submitting = 1
                let createData = this.create
                
                // Debug: Log the data being sent
                console.log('Creating customer with data:', createData)
                console.log('Customer name:', createData.name)

                let url = 'api/lists/customers/createcustomer'
                try {
                    const res = await axios.post(url, { 
                        createData,
                        force_create: forceCreate === true
                    })
                    
                    // Debug: Log the response
                    console.log('Create customer response:', res.data)
                    
                    if (res.data.status == 'success') {
                        // Store the created customer ID for card creation
                        this.createdCustomerId = res.data.customer_id
                        
                        // Save all pending cards (if any)
                        const pendingCardsCount = this.pendingCards.length
                        if (pendingCardsCount > 0) {
                            await this.savePendingCards()
                        }
                        
                        this.submitting = 0
                        this.closeModal(this.modalName)
                        const message = pendingCardsCount > 0 
                            ? `Customer created successfully! ${pendingCardsCount} card(s) added.`
                            : 'Customer created successfully!'
                        this.showAlertBox('success', 'Customer Created', message)
                        this.$emit('getRow')
                    } else if (res.data.status == 'warning') {
                        // Handle duplicate warning with confirmation dialog
                        this.submitting = 0
                        this.showDuplicateConfirmation(res.data)
                    } else {
                        this.submitting = 0
                        const errorMessage = res.data.message || 'Error creating customer!'
                        this.showAlertBox('error', 'Error', errorMessage)
                    }
                } catch (error) {
                    this.submitting = 0
                    // Handle error response with message
                    if (error.response && error.response.data) {
                        const errorData = error.response.data
                        const errorMessage = errorData.message || 'Error creating customer!'
                        this.showAlertBox('error', 'Error', errorMessage)
                    } else {
                        this.has_error = true
                    }
                }
            },
            
            showDuplicateConfirmation(data) {
                const existing = data.existing_customer
                const matchedFields = data.matched_fields || []
                
                // Build the confirmation message
                let message = 'A potential duplicate customer was found.\n\n'
                message += 'Matched fields: ' + matchedFields.join(', ') + '\n\n'
                message += 'Existing Customer Details:\n'
                
                if (existing.name) {
                    message += '• Name: ' + existing.name + '\n'
                }
                if (existing.email) {
                    message += '• Email: ' + existing.email + '\n'
                }
                if (existing.phone) {
                    message += '• Phone: ' + existing.phone + '\n'
                }
                if (existing.billing_address_1) {
                    message += '• Billing Address: ' + existing.billing_address_1 + '\n'
                }
                if (existing.shipping_address_1) {
                    message += '• Shipping Address: ' + existing.shipping_address_1 + '\n'
                }
                
                message += '\nDo you want to still create this customer?'
                
                // Show confirmation dialog
                this.$bvModal.msgBoxConfirm(message, {
                    title: 'Duplicate Customer Warning',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        // User confirmed - create customer anyway
                        this.createCustomer(true)
                    }
                    // If user clicks No, do nothing (form stays open)
                })
                .catch(err => {
                    // User cancelled or error occurred
                })
            },

            resetForm() {
                this.create = {
                    newCard: {
                        number: '',
                        exp: '',
                        cvc: ''
                    }
                }
                this.lists.cards = []
                this.pendingCards = []
                this.createdCustomerId = null
                this.submitting = 0
            },

            getPaymentTerms() {
                fetchActivePaymentTerms().then((terms) => {
                    this.lists.paymentMethods = terms
                })
            },

            getShippingMethods() {
                fetchActiveShippingMethods().then((methods) => {
                    this.lists.deliveryMethods = methods
                })
            },

            async loadPaymentConfig() {
                try {
                    const response = await axios.get('/api/payments/config')
                    if (response.data.success) {
                        this.paymentConfig = response.data.config
                    }
                } catch (error) {
                    console.warn('Could not load payment configuration, using defaults')
                }
            },

            createCard() {
                // Validate CVC if required by configuration
                if (this.paymentConfig.cvc_required && !this.create.newCard.cvc || !this.create.newCard.cvc.trim()) {
                    this.showAlertBox('error', 'Validation Error', 'CVC is required for card creation')
                    return
                }
                
                // Just add the card to pending cards (no API call yet)
                // Cards will be created when the main Create button is clicked
                this.pendingCards.push({
                    number: this.create.newCard.number.trim(),
                    exp: this.create.newCard.exp.trim(),
                    cvc: this.create.newCard.cvc ? this.create.newCard.cvc.trim() : null
                })
                
                // Clear the form
                this.create.newCard = {
                    number: '',
                    exp: '',
                    cvc: ''
                }
            },

            removePendingCard(index) {
                this.pendingCards.splice(index, 1)
            },

            async savePendingCards() {
                // Save all pending cards via API
                if (!this.createdCustomerId || this.pendingCards.length === 0) {
                    return
                }
                
                for (const card of this.pendingCards) {
                    try {
                        const res = await axios.post('api/lists/customers/createcard', {
                            customerId: this.createdCustomerId,
                            number: card.number,
                            exp: card.exp,
                            cvc: card.cvc
                        })
                        
                        if (res.data.status !== 'Success') {
                            console.error('Error creating card:', res.data.message || 'Error adding card!')
                            // Continue with other cards even if one fails
                        }
                    } catch (err) {
                        console.error('Error creating card:', err.response?.data?.message || 'Error adding card!')
                        // Continue with other cards even if one fails
                    }
                }
                
                // Clear pending cards after saving
                this.pendingCards = []
                
                // Refresh the cards list
                if (this.createdCustomerId) {
                    this.getCards()
                }
            },

            getCards() {
                if (!this.createdCustomerId) return
                
                let url = 'api/lists/customers/getcards/' + this.createdCustomerId
                axios.get(url, {})
                    .then((res) => {
                        this.lists.cards = res.data.cards
                    }, () => {
                        this.has_error = true
                    })
            },

            async makeDefault(cardId) {
                if (!this.createdCustomerId) return
                
                let url = 'api/lists/customers/makedefaultcard/' + this.createdCustomerId + '/' + cardId;
                try {
                    let res = await axios.post(url);
                    if (res.data.status === 'Success') {
                        this.lists.cards.forEach(card => { card.default = false; });
                        let found = this.lists.cards.find(card => card.id === cardId);
                        if (found) found.default = true;
                        this.$forceUpdate();
                    } else {
                        this.showAlertBox('error', 'Error', 'Failed to set default card!');
                    }
                } catch (e) {
                    this.showAlertBox('error', 'Error', 'Failed to set default card!');
                }
            },

            deleteCard(cardId) {
                if (!window.confirm('Are you sure you want to delete this card?')) return;
                let url = 'api/lists/customers/deletecard/' + cardId
                axios.get(url, {})
                    .then((res) => {
                        this.getCards()
                    }, () => {
                        this.has_error = true
                    })
            },

            formatCardNumber() {
                // Remove all non-digit characters and limit to 16 digits
                if (this.create.newCard.number) {
                    this.create.newCard.number = this.create.newCard.number.replace(/\D/g, '').substring(0, 16);
                }
            },

            formatExpiry() {
                // Remove all non-digit characters and format as MM/YY
                if (this.create.newCard.exp) {
                    let value = this.create.newCard.exp.replace(/\D/g, '');
                    if (value.length >= 2) {
                        value = value.substring(0, 2) + '/' + value.substring(2, 4);
                    }
                    this.create.newCard.exp = value.substring(0, 5);
                }
            },

            formatCVC() {
                // Remove all non-digit characters and limit to 4 digits (for Amex)
                // Preserve leading zeros by treating as string
                if (this.create.newCard.cvc) {
                    let cleaned = this.create.newCard.cvc.replace(/\D/g, '');
                    this.create.newCard.cvc = cleaned.substring(0, 4);
                }
            },

            formatCardDisplay(value, fieldType) {
                // Check if user has permission to view full card details
                const canViewFullCard = this.$can('view-customer-detail-payment-method-full-card') || this.$can('view-all')
                
                if (!value) return ''
                
                if (canViewFullCard) {
                    // Show full details with formatting
                    if (fieldType === 'number') {
                        // Format card number with dashes for better readability
                        const cleaned = value.replace(/\D/g, '')
                        const formatted = cleaned.replace(/(\d{4})(?=\d)/g, '$1-')
                        return formatted.slice(0, 19) // Ensure it doesn't exceed 19 characters
                    } else if (fieldType === 'exp') {
                        return value
                    } else if (fieldType === 'cvc') {
                        return value
                    }
                } else {
                    // Mask sensitive information
                    if (fieldType === 'number') {
                        // Show only last 4 digits
                        if (value.length > 4) {
                            return 'XXXX-XXXX-XXXX-' + value.substring(value.length - 4)
                        }
                        return value
                    } else if (fieldType === 'exp') {
                        // Always show expiration date, never mask it
                        return value
                    } else if (fieldType === 'cvc') {
                        return 'XXX'
                    }
                }
                
                return value
            },

            showAlertBox(type, title, message, isHtml = false) {
                // Simple alert box implementation
                const toastOptions = {
                    title: title,
                    variant: type === 'success' ? 'success' : 'danger',
                    solid: true,
                    autoHideDelay: type === 'success' ? 5000 : 8000, // 8 seconds for errors, 5 for success
                    noAutoHide: false, // Ensure auto-hide is enabled
                    toaster: 'b-toaster-top-right'
                }
                
                if (isHtml) {
                    toastOptions.html = true
                }
                
                this.$bvToast.toast(message, toastOptions)
            },
            
            escapeHtml(text) {
                if (!text) return ''
                const map = {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&#039;'
                }
                return text.toString().replace(/[&<>"']/g, m => map[m])
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            }
		},

		computed: {

		},

		mounted() {
            this.getPaymentTerms()
            this.getShippingMethods()
            this.loadPaymentConfig()
		}
	}
</script>
<style lang="scss">
    #modal-lists-customers-create-customer {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }

            .default-card {
                width: 1px;
            }

            .highlight-green {
                background-color: green;
            }

            .pending-card-row {
                background-color: #fff3cd;
                opacity: 0.8;
            }

            .table {
                width: 100%;
            }
        }
    }
</style>
